module.exports = __webpack_public_path__ + "img/Inspection6.4a6d9956.png";